/**
 * The three ways the link can fail, drawn three different ways.
 *
 * Nothing new was invented for these: a lost signal is the toast's ink chip on
 * the table, held rather than flashed, and a closed table is the same sheet a
 * pause already rises in. Brass is not spent here — a connection is not whose
 * turn it is — so both are type on an existing surface.
 */
import { useEffect, useState } from 'react'
import { Sheet } from '../table/PromptSheet'
import { offlineSentence, type ConnectionState } from './connection'

/** Held for as long as the socket is down. The second line is about the table
 *  rather than the network, because "your seat is held" is what the player
 *  wants to know, and after half a minute it says so more plainly. */
export function OfflineNotice({ connection }: { connection: ConnectionState }): JSX.Element {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 5000)
    return () => window.clearInterval(timer)
  }, [])
  return (
    <div className="conn" role="status">
      <b>Reconnecting…</b>
      <span>{offlineSentence(connection, now)}</span>
    </div>
  )
}

/** The table is gone on the server — expired, closed, or never there. The
 *  reason is the server's own sentence, so the player is told which. */
export function TableClosedNotice({
  reason,
  onLeave,
}: {
  reason: string
  onLeave: () => void
}): JSX.Element {
  return (
    <Sheet>
      <div className="sheet-body">
        <h2>This table has closed</h2>
        <p className="muted">{reason}</p>
        <button className="btn btn-primary btn-block" onClick={onLeave}>
          Back to the lobby
        </button>
      </div>
    </Sheet>
  )
}
